import React, { Component } from "react";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";
import { withTranslation } from "react-i18next";
import queryString from "query-string";
import { withRouter, Link } from "react-router-dom";
import { Row, Col, Container, Button } from "react-bootstrap";
import WithError from "../common/WithError";
import http from "../../api/http-request";
import {
  getLoginUrl,
  getRoutePath,
  isPasswordFormatValid,pageNotFound,randomCount
} from "../../utils/common";
import PasswordRequirements from "../PasswordRequirements";
import PasswordField from "../common/PasswordField";
import Carousel1 from "../../assets/images/reg1.jpg";
import Carousel2 from "../../assets/images/reg2.jpg";
import Carousel3 from "../../assets/images/reg3.jpg";
import Carousel4 from "../../assets/images/reg4.jpg";
import Carousel5 from "../../assets/images/reg5.jpg";
import Carousel6 from "../../assets/images/reg6.jpg";
import Carousel7 from "../../assets/images/reg7.jpg";
import Carousel9 from "../../assets/images/reg9.jpg";
class ResetYourPasswordFromMail extends Component {
  constructor(props) {
    super(props);
    this.newPasswordInputRef = React.createRef();
    this.confirmPasswordInputRef = React.createRef();
    this.state = {
      showSuccessMsg: false,
      tokenExpired: false,
      showErrorMsg: false,
      confirmPassword: "",
      password: "",
      token: "",
      passwordError: "",
      formSubmitted: false,
      showPasswordResetScreen: false,
      carouselImages: [{'image':Carousel1},{'image':Carousel2},{'image':Carousel3},{'image':Carousel4},{'image':Carousel5},{'image':Carousel6},{'image':Carousel7},{'image':Carousel9}],
      imageIndex:null
    };
  }

  componentDidMount() {
    this.getToken();
    this.displayRandomImage();
  }
  displayRandomImage = () => {
    this.setState({
      imageIndex: randomCount()
    });
  };

  getToken = () => {
    const {
      location: { search }
    } = this.props;
    const { token, code } = queryString.parse(search);
    http(
      {
        url: "selfservice/reset?_action=submitRequirements",
        data: { input: { token, code }, token },
        method: "POST"
      },
      {
        "X-OpenIDM-NoSession": true,
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous"
      }
    ).then((res) => {
      this.setState({
        showPasswordResetScreen: true
      });
      if (res.status === 200 && res.data && res.data.type === 'resetStage') {
        this.setState({
          token: res.data.token
        });
      } else if (
        res.status === 400 &&
        (res.data.message === "Snapshot token is invalid" || res.data.message === "The link has expired")
      ) {
        this.setState({
          showErrorMsg: true,
          tokenExpired: true
        });
      } 
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {
        this.setState({
          showErrorMsg: true,
          tokenExpired: ""
        });
      }
    });
  };

  submitNewPassword = (e) => {
    e.preventDefault();
    const { password, confirmPassword, token } = this.state;
    const hasPassword = this.isFormFieldValid(password, "passwordError");
    const hasConfirmPassword = this.isFormFieldValid(
      confirmPassword,
      "confirmPasswordError"
    );
    this.setState({
      formSubmitted: true
    });
    if (hasPassword || hasConfirmPassword) {
      this.showError("common.errors.required");
    } else {
      this.setState({
        formSubmitted: false,
        errorText: ""
      });
      http(
        {
          url: "selfservice/reset?_action=submitRequirements",
          data: { input: { password }, token },
          method: "POST"
        },
        {
          "X-OpenIDM-NoSession": true,
          "X-OpenIDM-Username": "anonymous",
          "X-OpenIDM-Password": "anonymous"
        }
      ).then((res) => {
        if (res.status === 200 && res.data && res.data.status && res.data.status.success) {
          this.setState({
            showSuccessMsg: true
          });
        } else if (
          res.status === 200 &&
          res.data.requirements &&
          res.data.requirements.error &&
          res.data.requirements.error.code === 403 &&
          res.data.requirements.error.detail.failedPolicyRequirements[0]
            .policyRequirements[0].policyRequirement === "IS_NEW"
        ) {
          this.showError("pages.passwordReset.mustBeNewPassword");
        } else if (
          res.status === 400 &&
          res.data.message === "Snapshot token is invalid"
        ) {
          this.setState({
            showErrorMsg: true
          });
        } 
        else if(res.status === 200 && res.data && typeof res.data === 'string'){
          pageNotFound(res);
        }
        else {
          this.setState({
            showErrorMsg: true
          });
        }
      });
    }
  };

  isFormFieldValid = (e, key) => {
    const value = e.target ? e.target.value.trim() : e;
    const { password, confirmPassword } = this.state;

    let errorMsg = "";
    switch (key) {
      case "passwordError":
        if (value.length <= 0) {
          errorMsg = "common.errors.noPasswordError";
        } else if (isPasswordFormatValid(value)) {
          errorMsg = "common.errors.invalidFormat";
        }
        break;
      case "confirmPasswordError":
        if (value.length <= 0) {
          errorMsg = "common.errors.noConfirmPasswordError";
        } else if (password !== confirmPassword) {
          errorMsg = "common.errors.passwordsError";
        }
        break;
      default:
        errorMsg = "";
        break;
    }
    this.setState({
      [key]: errorMsg
    });
    return errorMsg;
  };

  showError = (errorText) => {
    this.setState({
      errorText
    });
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
  };

  render() {
    const { t } = this.props;
    const {
      errorText,
      showSuccessMsg,
      showErrorMsg,
      tokenExpired,
      password,
      passwordError,
      confirmPassword,
      confirmPasswordError,
      formSubmitted,
      showPasswordResetScreen,
      carouselImages,
      imageIndex
    } = this.state;
    return (
      <>
      <div className={`has-background background-new-image ${errorText && "has-error"}`} style={{ backgroundImage: `url(${carouselImages[imageIndex || 1].image})` }}>
        <div className="wrapper password-reset password-reset-email">
        {errorText && <WithError errors={errorText} />}
          <Container
            className={`container wrapper__container ${
              errorText && "haserror"
            }`}
          >
            {showPasswordResetScreen && (
              <Row>
                <Col lg={{ span: 6 }}>
                  <div className="wrapper__container-card">
                    <div className="wrapper__container-card-body">
                      {!showSuccessMsg && !showErrorMsg && (
                        <h1 className="wrapper__container-card-body-title has-desc">
                          {t("pages.passwordReset.resetPassword")}
                        </h1>
                      )}
                      {!showSuccessMsg && !showErrorMsg && (
                        <>
                          <p className="wrapper__container-card-body-desc">
                            {t("pages.passwordReset.enterYourPassword")}
                          </p>
                          <Form>
                            <Form.Group controlId="passWord">
                              <Form.Label>
                                {t("pages.registration.password")}
                              </Form.Label>
                              <PasswordField
                                onChange={(value) => {
                                  this.setState({
                                    password: value
                                  },
                                  () => {
                                    if (confirmPassword !== '') {
                                      this.isFormFieldValid(
                                        value,
                                        "confirmPasswordError"
                                      );
                                    }
                                  });
                                }}
                                onBlur={(e) => {
                                  this.isFormFieldValid(e, "passwordError");
                                }}
                                password={password}
                                className={
                                  passwordError ? "error-input" : undefined
                                }
                                ariaInvalid={!!passwordError}
                                ariaDescribedby="password-error password-requirements"
                                myRef={this.newPasswordInputRef}
                              />
                            </Form.Group>
                            <p
                              className="error-text password-error"
                              id="password-error"
                            >
                              {t(passwordError)}
                            </p>
                            <PasswordRequirements
                              password={password}
                              formSubmitted={formSubmitted}
                              showPasswordDiffItem
                              errorText={errorText}
                            />
                            <Form.Group controlId="confirmPassWord">
                              <Form.Label>
                                {t("pages.registration.confirmPassword")}
                              </Form.Label>
                              <PasswordField
                                onChange={(value) => {
                                  this.setState(
                                    {
                                      confirmPassword: value
                                    },
                                    () => {
                                      this.isFormFieldValid(
                                        value,
                                        "confirmPasswordError"
                                      );
                                    }
                                  );
                                }}
                                onBlur={(e) => {
                                  this.isFormFieldValid(
                                    e,
                                    "confirmPasswordError"
                                  );
                                }}
                                password={confirmPassword}
                                className={
                                  confirmPasswordError
                                    ? "error-input"
                                    : undefined
                                }
                                ariaInvalid={!!confirmPasswordError}
                                ariaDescribedby="confirm-password-error"
                                myRef={this.confirmPasswordInputRef}
                                onCopy={(e) => {
                                  e.preventDefault();
                                  e.nativeEvent.stopImmediatePropagation();
                                }}
                                onPaste={(e) => {
                                  e.preventDefault();
                                  e.nativeEvent.stopImmediatePropagation();
                                }}
                              />
                            </Form.Group>

                            <p
                              className="error-text"
                              id="confirm-password-error"
                            >
                              {confirmPasswordError && t(confirmPasswordError)}
                            </p>
                            <Button
                              className="wrapper__container-card-body-submit"
                              size="lg"
                              variant="primary"
                              block
                              type="submit"
                              onClick={(e) => this.submitNewPassword(e)}
                            >
                              {t("pages.passwordReset.resetPasswordLabel")}
                            </Button>
                          </Form>
                        </>
                      )}
                      {showErrorMsg && (
                        <div className="notification-error">
                          <div
                            className="notification-error-card"
                            role="alert"
                            aria-live="polite"
                          >
                            <p className="notification-error-card__title">
                              {t("pages.passwordReset.errorMessageTitle")}
                            </p>
                            {tokenExpired !== "" && (
                              <p className="notification-error-card__text">
                                {tokenExpired
                                  ? t("pages.passwordReset.linkHasExpired")
                                  : t("pages.passwordReset.linkExpiredMessage")}
                              </p>
                            )}
                          </div>
                          <a href={`${getRoutePath}/passwordreset`}>
                            {t("pages.passwordReset.errorMessageLink")}
                          </a>
                        </div>
                      )}
                      {showSuccessMsg && (
                        <div
                          className="notification-card"
                          role="alert"
                          aria-live="polite"
                        >
                          <p className="notification-card__text">
                            {t("pages.passwordReset.passwordResetSuccess")}
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="separator" />
                    <div className="text-center wrapper__container-card-register">
                      {t("pages.registration.alreadyHaveAccount")}{" "}
                      <Link to={getLoginUrl()}>
                        {t("pages.registration.login")}
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            )}
          </Container>
        </div>
        </div>
      </>
    );
  }
}

ResetYourPasswordFromMail.propTypes = {
  t: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired
};

export default withTranslation()(withRouter(ResetYourPasswordFromMail));
